// extracted by mini-css-extract-plugin
export default {"app":"styles_app__wQJSM","form":"styles_form__3zacx"};